export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm"
export const DATE_FORMAT = "yyyy-MM-dd"

export const DATETIME_FORMAT_ROUND_DOWN = "yyyy-MM-dd HH:00"

export const READABLE_DATETIME_FORMAT = "yyyy MMM dd HH:mm"
export const READABLE_DATETIME_FORMAT_ROUND_DOWN = "yyyy MMM dd HH:00"
